import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

function InputsLabel({ additionalClassName = {}, ctaElement, headerText, isRequired, subHeaderText }) {
  const containerClassName = classNames("flex flex-col gap-1", additionalClassName.container);
  const headerTextClassName = classNames("font-md text-base text-onyx", additionalClassName.header);
  const subHeaderTextClassName = classNames("text-sm text-darkGray mt-1", additionalClassName.subHeader);

  return (
    <div className={containerClassName} data-test-id="input-label-container">
      <div className="flex items-center justify-between">
        <p className={headerTextClassName}>
          {headerText}
          {isRequired && "*"}
        </p>
        {ctaElement}
      </div>
      {subHeaderText && <div className={subHeaderTextClassName}>{subHeaderText}</div>}
    </div>
  );
}

InputsLabel.propTypes = {
  additionalClassName: PropTypes.shape({
    container: PropTypes.string,
    header: PropTypes.string,
    subHeader: PropTypes.string,
  }),
  ctaElement: PropTypes.node,
  headerText: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  subHeaderText: PropTypes.string,
};

export default InputsLabel;
